export const LogoMark = ({ size = 40 }) => (
  <img
    src="/logo-mark.jpg"
    alt="Logo TPLM Guyane"
    data-testid="logo-mark"
    className="rounded-lg bg-white object-contain px-1.5 py-1"
    style={{ height: size, width: "auto" }}
  />
);

export const LogoFull = ({ size = 40 }) => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark size={size} />
    <span className="hidden sm:block font-mono text-[10px] tracking-[0.35em] text-[#F2541B] uppercase leading-none">
      Guyane
    </span>
  </div>
);
